import {doApi} from './core';

export function reverseGeocode(language, params) {
    return doApi(language, params, '/mixed/maps/reverse-geocode');
}

export function geocode(language, params) {
    return doApi(language, params, '/mixed/maps/geocode');
}

export function findPlaceFromText(language, params) {
    return doApi(language, params, '/mixed/maps/find-place-from-text');
}

export function placesAutocomplete(language, params) {
    return doApi(language, params, '/mixed/maps/places-autocomplete');
}

export function placeDetail(language, params) {
    return doApi(language, params, '/mixed/maps/place-detail');
}

export function getCountries(language, params) {
    return doApi(language, params, '/mixed/countries/get');
}
